import { render, staticRenderFns } from "./DriverApprovalSearch.vue?vue&type=template&id=ece139b4&scoped=true"
import script from "./DriverApprovalSearch.vue?vue&type=script&lang=js"
export * from "./DriverApprovalSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ece139b4",
  null
  
)

export default component.exports